import { Stack, Typography } from "@mui/joy";
import { ICellRendererParams } from "ag-grid-community";

const getSpecialistText = (score: number | string): string => {
  const parsedScore = Number(score);

  switch (parsedScore) {
    case 0:
      return "Little";
    case 1:
      return "I am familiar";
    case 2:
      return "I Rock";
    case 3:
      return "I am all Star";
    case -1:
      return "No Interest";
    default:
      return "NA";
  }
};

function SpecialistTextCellRenderer({ value }: ICellRendererParams<any>) {
  return (
    <Stack direction="row" alignItems="center" gap={1}>
      <Typography component={"span"} noWrap>
        {getSpecialistText(value)}
      </Typography>
    </Stack>
  );
}

export default SpecialistTextCellRenderer;
